import React from 'react';
import { TextField } from '@mui/material';
import { styled } from '@mui/system';

const CustomTextField = styled(TextField)(({ theme, customWidth, customMarginTop , customMarginLeft}) => ({
  width: customWidth || '400px',
  marginTop: customMarginTop || '0px',
  marginLeft: customMarginLeft || '0px' ,
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    borderColor: '#E7E7FF',
    borderWidth: '1px',
    '&:hover fieldset': {
      borderColor: '#E7E7FF',
    },
    '& fieldset': {
      border: '1px solid #E7E7FF',
      padding: '18px 15px',
      borderRadius: '10px',
    },
    '& input': {
      color: '#B2B4C5 !important',
      fontSize: '13px !important',
      fontFamily: 'Figtree-Regular',
      marginLeft:'7px',
      '&:focus': {
        '& + fieldset': {
          borderColor: '#E7E7FF',
        },
      },
    },
    '& label': {
      color: '#B2B4C5 !important',
      fontWeight: `600 !important`,
      fontSize: '13px !important',
      fontFamily: 'Figtree-Bold !important',
      transform: 'translate(18px, 12px) scale(1) !important',
      '&.Mui-focused': {
        color: '#B2B4C5 !important',
      },
    },
    '& .Mui-focused fieldset': {
      border: '1px solid #E7E7FF !important',
      borderColor: '#E7E7FF',
    },
    '& .Mui-focused label': {
      transform: 'translate(18px, -10px) scale(0.75) !important',
    },
  },
}));

const TextFieldForModals = ({onFocusFn, onBlurFn, value, type, label, onChangeFn, customWidth, placeholder, customMarginTop , customMarginLeft}) => {
  return (
    <CustomTextField
      id="outlined-required"
      label={label}
      value={value}
      type={type || 'text'}
      onChange={onChangeFn}
      variant="outlined"
      onFocus={onFocusFn}
      onBlur={onBlurFn}
      placeholder={placeholder}
      customWidth={customWidth}
      customMarginTop={customMarginTop}
      InputLabelProps={{
        shrink: true,
        style: {
          color: '#404585',
          fontFamily: 'Figtree-Regular',
          fontWeight:'600',
          transform: 'translate(20px, -9px) scale(0.75)',
        }
      }}
      customMarginLeft={customMarginLeft}
    />
  );
};

export default TextFieldForModals;
